import React from "react";
import { Spinner as LoadingSpinner  } from "react-bootstrap";

const Spinner = ({variant ="primary",animation ="border",size=null})=>{
    return <LoadingSpinner variant={variant} animation={animation} size={size}/>
}

export default Spinner